export enum DeviceAuthStatus {
  rejected = 'REJECTED',
  pending = 'PENDING',
  approved = 'APPROVED'
}
